const SummaryTableSchema = [
    {
        objectName: 'selectedPurchaseOrderLine',
        isLoading: 'loadingPurchaseOrderLineDetailsSummary',
        children: [
            {
                label: 'Product',
                fieldNames: [
                    'ProductIdDisplay',
                    'ProductDescription'
                ],
                valueRenderer: {
                    hyperLink: {
                        link: false,
                        menu: true
                    },
                    api: {
                        api: '/inventoryEnquiry/lookup/action',
                        name: 'enquiry',
                        params: {
                            queryFields: {
                                ProductId: 'ProductId'
                            }
                        }
                    }
                }
            },
            {
                label: 'Product Group',
                fieldNames: [
                    'ProductGroup',
                ]
            },
            {
                label: 'Stock Unit',
                fieldNames: [
                    'UnitCode'
                ]
            },
        ]
    },
    {
        objectName: 'selectedPurchaseOrderLine',
        isLoading: 'loadingPurchaseOrderLineDetailsSummary',
        children: [
            {
                label: 'Average Cost',
                fieldNames: [
                    'CostDisplay',
                ],
                valueRenderer: {
                    isNumericDisplay: true
                }
            },
            {
                label: 'Last Buy',
                fieldNames: [
                    'LastBuyDisplay',
                ],
                valueRenderer: {
                    isNumericDisplay: true
                }
            }
        ]
    },
    {
        objectName: 'selectedPurchaseOrderLine',
        isLoading: 'loadingPurchaseOrderLineDetailsSummary',
        children: [
            {
                label: 'Supplied',
                fieldNames: [
                    'SuppliedQuantityDisplay'
                ],
                valueRenderer: {
                    isNumericDisplay: true
                }
            },
            {
                label: 'In Transit',
                fieldNames: [
                    'InTransitQuantityDisplay'
                ],
                valueRenderer: {
                    isNumericDisplay: true
                }
            },
            {
                label: 'Committed',
                fieldNames: [
                    'CommittedQuantityDisplay'
                ],
                valueRenderer: {
                    isNumericDisplay: true
                }
            },
        ]
    },
    {
        objectName: 'selectedPurchaseOrderLine',
        isLoading: 'loadingPurchaseOrderLineDetailsSummary',
        children: [
            {
                label: 'Extended Total',
                fieldNames: [
                    'ExtendedTotalDisplay'
                ],
                valueRenderer: {
                    isNumericDisplay: true,
                    emphasize: true
                }
            },
        ]
    },
];

export default SummaryTableSchema;
